import { InboxMenu } from '@platform/features/users/inbox/InboxMenu';
import { navGroup } from '@platform/navigation';
import { HomeMenu } from '../HomeMenu';
import { AdminMenu } from '../pages/admin/AdminMenu';
import { AreaMenu } from '../pages/area/AreaMenu';
import { CustomizeMenu } from '../pages/customize/CustomizeMenu';
import type { IShellMenuProps } from './IShellMenuProps';
import { ModulesRail } from './ModulesRail';
import { SearchMenu } from './SearchMenu';

/**
 * Ліве меню системних сторінок робочого простору (прототип v4): «Мої вхідні» — меню вхідних, «Усі модулі» — колонка категорій, огляд
 * напряму (`/<група>`, ADR-028) — меню напряму, «Адміністрування» й «Налаштування» — меню системних модулів, пошук — меню поточного модуля (як у прототипі),
 * решта (Головна, «Моя робота», нещодавні, обране, бізнес-аналітика, учасники, профіль) — меню Головної.
 */
export function ShellMenu({ ws, pathname }: IShellMenuProps) {
  const page = decodeURIComponent(pathname.split('/')[1] ?? '');
  if (page === 'inbox') return <InboxMenu ws={ws} />;
  if (page === 'modules') return <ModulesRail ws={ws} />;
  if (navGroup(page)) return <AreaMenu ws={ws} group={page} />;
  if (page === 'admin') return <AdminMenu ws={ws} />;
  if (page === 'customize') return <CustomizeMenu ws={ws} />;
  if (page === 'search') return <SearchMenu ws={ws} />;
  return <HomeMenu ws={ws} />;
}
